import React from 'react'
import { LocalizationProvider } from '@fluent/react'
import { getL10n } from '../helpers/l10nForPlugin'

export const LocalePluginProvider = ({ children }) => {
  const [l10nReady, setL10nReady] = React.useState(false)
  const intervalRef = React.useRef(null)

  React.useEffect(() => {
    intervalRef.current = setInterval(() => {
      const l10n = getL10n()
      if (!l10n) return

      setL10nReady(true)
      clearInterval(intervalRef.current)
    }, 150)
    return () => clearInterval(intervalRef.current)
  }, [])

  if (!l10nReady) return <span>Loading...</span>

  return (
    <LocalizationProvider l10n={getL10n()}>{children}</LocalizationProvider>
  )
}
